import { FC, useEffect, useState } from 'react'

import { Button } from 'ui'
import { useGetUrl } from 'components/Hooks'
import { UPLOAD_ATTACHMENTS_TYPES } from 'common'

const AttachmentsList: FC<{ files: MData.File[] }> = ({ files }) => {
  if (!files?.length) return null
  return (
    <div className="d-flex flex-column">
      {files.map(file => (
        <AttachmentLink key={file.key} file={file} />
      ))}
    </div>
  )
}
const AttachmentLink: FC<{ file: MData.File }> = ({ file }) => {
  const { getUrlHandler } = useGetUrl({ attachmentType: UPLOAD_ATTACHMENTS_TYPES.SHIFT })
  const [url, setUrl] = useState<string>()

  useEffect(() => {
    if (!file || url !== undefined) return
    const getUrl = async () => {
      const response = await getUrlHandler({ key: file.key })
      if (response) setUrl(response)
    }
    getUrl()
  }, [file, getUrlHandler, url])

  return (
    <div className="d-flex flex-row align-items-baseline ">
      <i className="fa-regular fa-paperclip-vertical fa-sm"></i>
      <Button className="ml-1 text-left text-break" isLink onClick={() => window.open(url, '_blank')} data-cy="Attachment_link">
        <small>{file.name}</small>
      </Button>
    </div>
  )
}

export default AttachmentsList
